

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchAllTaskSubmissions } from "../redux/actions/taskActions";

// const Task = () => {
//   const dispatch = useDispatch();
//   const { taskSubmissions, loading, error } = useSelector((state) => state.task);

//   const [photoModalOpen, setPhotoModalOpen] = useState(false);
//   const [selectedTask, setSelectedTask] = useState(null);

//   const [searchName, setSearchName] = useState("");
//   const [searchPhone, setSearchPhone] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [selectedTaskTitle, setSelectedTaskTitle] = useState("");
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

//   const itemsPerPage = 10;

//   useEffect(() => {
//     dispatch(fetchAllTaskSubmissions());
//   }, [dispatch]);

//   const openPhotoModal = (task) => {
//     setSelectedTask(task);
//     setPhotoModalOpen(true);
//   };

//   const closePhotoModal = () => {
//     setPhotoModalOpen(false);
//     setSelectedTask(null);
//   };

//   const uniqueTaskTitles = [...new Set(taskSubmissions.map((t) => t.task_title).filter(Boolean))];
//   const uniqueDistricts = [...new Set(taskSubmissions.map((t) => t.user_district).filter(Boolean))];

//   const filteredTasks = taskSubmissions.filter((task) => {
//     const matchesName = task.user_name?.toLowerCase().includes(searchName.toLowerCase());
//     const matchesPhone = task.user_phone?.includes(searchPhone);
//     const matchesTitle = selectedTaskTitle ? task.task_title === selectedTaskTitle : true;
//     const matchesDistrict = selectedDistrict ? task.user_district === selectedDistrict : true;

//     const taskDate = task.date ? new Date(task.date).setHours(0, 0, 0, 0) : null;
//     const fromDateValid = fromDate ? taskDate >= new Date(fromDate).setHours(0, 0, 0, 0) : true;
//     const toDateValid = toDate ? taskDate <= new Date(toDate).setHours(0, 0, 0, 0) : true;

//     return matchesName && matchesPhone && matchesTitle && matchesDistrict && fromDateValid && toDateValid;
//   });

//   const totalPages = Math.ceil(filteredTasks.length / itemsPerPage);
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredTasks.slice(indexOfFirstItem, indexOfLastItem);

//   const handleResetDate = () => {
//     setFromDate("");
//     setToDate("");
//     setCurrentPage(1);
//   };

//   return (
//     <div className="w-full h-auto bg-gray-100 p-4">
//       <h1 className="text-2xl font-bold mb-4">Task Submissions</h1>

//       {/* Filters */}
//       <div className="flex flex-wrap gap-2 mb-4">
//         <select
//           value={selectedTaskTitle}
//           onChange={(e) => { setSelectedTaskTitle(e.target.value); setCurrentPage(1); }}
//           className="px-3 py-2 border border-gray-300 rounded-md"
//         >
//           <option value="">All Task Titles</option>
//           {uniqueTaskTitles.map((title) => (
//             <option key={title} value={title}>{title}</option>
//           ))}
//         </select>

//         <select
//           value={selectedDistrict}
//           onChange={(e) => { setSelectedDistrict(e.target.value); setCurrentPage(1); }}
//           className="px-3 py-2 border border-gray-300 rounded-md"
//         >
//           <option value="">All Districts</option>
//           {uniqueDistricts.map((district) => (
//             <option key={district} value={district}>{district}</option>
//           ))}
//         </select>

//         <input
//           type="text"
//           placeholder="Search by name"
//           value={searchName}
//           onChange={(e) => { setSearchName(e.target.value); setCurrentPage(1); }}
//           className="px-3 py-2 border border-gray-300 rounded-md"
//         />
//         <input
//           type="text"
//           placeholder="Search by phone"
//           value={searchPhone}
//           onChange={(e) => { setSearchPhone(e.target.value); setCurrentPage(1); }}
//           className="px-3 py-2 border border-gray-300 rounded-md"
//         />
//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }}
//           className="px-3 py-2 border border-gray-300 rounded-md"
//         />
//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }}
//           className="px-3 py-2 border border-gray-300 rounded-md"
//         />
//         <button
//           onClick={handleResetDate}
//           className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300"
//         >
//           Reset Date
//         </button>
//       </div>

//       {loading ? (
//         <p>Loading tasks...</p>
//       ) : error ? (
//         <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded">
//           Error: {error}
//         </div>
//       ) : filteredTasks.length > 0 ? (
//         <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
//           <table className="min-w-[1200px] w-full text-sm text-left">
//             <thead className="bg-black text-white">
//               <tr>
//                 <th className="px-4 py-3">#</th>
//                 <th className="px-4 py-3">Photo</th>
//                 <th className="px-4 py-3">Task Title</th>
//                 <th className="px-4 py-3">User</th>
//                 <th className="px-4 py-3">Phone</th>
//                 <th className="px-4 py-3">District</th>
//                 <th className="px-4 py-3">Date</th>
//                 <th className="px-4 py-3">Time</th>
//                 <th className="px-4 py-3">Address</th>
//                 <th className="px-4 py-3">Latitude</th>
//                 <th className="px-4 py-3">Longitude</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {currentItems.map((task, index) => (
//                 <tr key={task.submit_id} className="hover:bg-gray-50">
//                   <td className="px-4 py-2">{indexOfFirstItem + index + 1}</td>
//                   <td className="px-4 py-2">
//                     <button
//                       onClick={() => openPhotoModal(task)}
//                       className="text-blue-600 underline hover:text-blue-800"
//                     >
//                       View
//                     </button>
//                   </td>
//                   <td className="px-4 py-2">{task.task_title}</td>
//                   <td className="px-4 py-2">{task.user_name}</td>
//                   <td className="px-4 py-2">{task.user_phone}</td>
//                   <td className="px-4 py-2">{task.user_district}</td>
//                   <td className="px-4 py-2">{new Date(task.date).toLocaleDateString("en-IN")}</td>
//                   <td className="px-4 py-2">{task.time}</td>
//                   <td className="px-4 py-2 max-w-[200px] break-words">{task.address}</td>
//                   <td className="px-4 py-2">{task.latitude}</td>
//                   <td className="px-4 py-2">{task.longitude}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination */}
//           <div className="flex justify-between items-center p-4 border-t">
//             <button
//               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//               className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
//             >
//               Previous
//             </button>
//             <p className="text-sm">Page {currentPage} of {totalPages}</p>
//             <button
//               onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//               disabled={currentPage === totalPages}
//               className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       ) : (
//         <p>No task submissions found.</p>
//       )}

//       {/* Photo Modal */}
//       {photoModalOpen && selectedTask && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-4 rounded shadow-lg relative max-w-sm">
//             <button
//               onClick={closePhotoModal}
//               className="absolute top-2 right-2 text-gray-600 hover:text-black"
//             >
//               ✖
//             </button>
//             <img
//               src={selectedTask.submit_photo}
//               alt="Task Submission"
//               className="w-full h-auto max-h-[80vh] object-contain"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Task;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllTaskSubmissions } from "../redux/actions/taskActions";

const Task = () => {
  const dispatch = useDispatch();
  const { taskSubmissions, loading, error } = useSelector((state) => state.task);

  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  const [searchName, setSearchName] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedTaskTitle, setSelectedTaskTitle] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  useEffect(() => {
    dispatch(fetchAllTaskSubmissions());
  }, [dispatch]);

  const openPhotoModal = (task) => {
    setSelectedTask(task);
    setPhotoModalOpen(true);
  };

  const closePhotoModal = () => {
    setPhotoModalOpen(false);
    setSelectedTask(null);
  };

  const uniqueTaskTitles = [...new Set(taskSubmissions.map((t) => t.task_title).filter(Boolean))];
  const uniqueDistricts = [...new Set(taskSubmissions.map((t) => t.user_district).filter(Boolean))];

  const filteredTasks = taskSubmissions.filter((task) => {
    const matchesName = task.user_name?.toLowerCase().includes(searchName.toLowerCase());
    const matchesPhone = task.user_phone?.includes(searchPhone);
    const matchesTitle = selectedTaskTitle ? task.task_title === selectedTaskTitle : true;
    const matchesDistrict = selectedDistrict ? task.user_district === selectedDistrict : true;

    const taskDate = task.date ? new Date(task.date).setHours(0, 0, 0, 0) : null;
    const fromDateValid = fromDate ? taskDate >= new Date(fromDate).setHours(0, 0, 0, 0) : true;
    const toDateValid = toDate ? taskDate <= new Date(toDate).setHours(0, 0, 0, 0) : true;

    return matchesName && matchesPhone && matchesTitle && matchesDistrict && fromDateValid && toDateValid;
  });

  const totalPages = Math.ceil(filteredTasks.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTasks.slice(indexOfFirstItem, indexOfLastItem);

  const handleResetDate = () => {
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
  };

  return (
    <div className="w-full h-auto bg-gray-100 p-4">
      <h1 className="text-2xl font-bold mb-4">Task Submissions</h1>

      {/* Filters */}
      <div className="flex flex-wrap gap-2 mb-4">
        <select
          value={selectedTaskTitle}
          onChange={(e) => { setSelectedTaskTitle(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        >
          <option value="">All Task Titles</option>
          {uniqueTaskTitles.map((title) => (
            <option key={title} value={title}>{title}</option>
          ))}
        </select>

        <select
          value={selectedDistrict}
          onChange={(e) => { setSelectedDistrict(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        >
          <option value="">All Districts</option>
          {uniqueDistricts.map((district) => (
            <option key={district} value={district}>{district}</option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Search by name"
          value={searchName}
          onChange={(e) => { setSearchName(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <input
          type="text"
          placeholder="Search by phone"
          value={searchPhone}
          onChange={(e) => { setSearchPhone(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <input
          type="date"
          value={fromDate}
          onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <input
          type="date"
          value={toDate}
          onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <button
          onClick={handleResetDate}
          className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300"
        >
          Reset Date
        </button>
      </div>

      {/* Loader / Error / Table */}
      {loading ? (
        <p>Loading tasks...</p>
      ) : error ? (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded">
          Error: {error}
        </div>
      ) : filteredTasks.length > 0 ? (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-[1200px] w-full text-sm text-left">
            <thead className="bg-black text-white">
              <tr>
                <th className="px-4 py-3">#</th>
                <th className="px-4 py-3">Photo</th>
                <th className="px-4 py-3">Task Title</th>
                <th className="px-4 py-3">User</th>
                <th className="px-4 py-3">Phone</th>
                <th className="px-4 py-3">District</th>
                <th className="px-4 py-3">Date</th>
                <th className="px-4 py-3">Time</th>
                <th className="px-4 py-3">Address</th>
                <th className="px-4 py-3">Latitude</th>
                <th className="px-4 py-3">Longitude</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {currentItems.map((task, index) => (
                <tr key={task.submit_id} className="hover:bg-gray-50">
                  <td className="px-4 py-2">{indexOfFirstItem + index + 1}</td>
                  <td className="px-4 py-2">
                    {task.submit_photo ? (
                      <button
                        onClick={() => openPhotoModal(task)}
                        className="text-blue-600 underline hover:text-blue-800"
                      >
                        View
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="px-4 py-2">{task.task_title}</td>
                  <td className="px-4 py-2">{task.user_name}</td>
                  <td className="px-4 py-2">{task.user_phone}</td>
                  <td className="px-4 py-2">{task.user_district}</td>
                  <td className="px-4 py-2">{new Date(task.date).toLocaleDateString("en-IN")}</td>
                  <td className="px-4 py-2">{task.time}</td>
                  <td className="px-4 py-2 max-w-[200px] break-words">{task.address}</td>
                  <td className="px-4 py-2">{task.latitude}</td>
                  <td className="px-4 py-2">{task.longitude}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-between items-center p-4 border-t">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Previous
            </button>
            <p className="text-sm">Page {currentPage} of {totalPages}</p>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        <p>No task submissions found.</p>
      )}

      {/* Photo Modal */}
      {photoModalOpen && selectedTask && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded shadow-lg relative max-w-sm">
            <button
              onClick={closePhotoModal}
              className="absolute top-2 right-2 text-gray-600 hover:text-black"
            >
              ✖
            </button>
            <img
              src={selectedTask.submit_photo}
              alt="Task Submission"
              className="w-full h-auto max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Task;
